import ReviewOutput from '@app/model/review/output/ReviewOutput';
import { useReviewsTools } from '@app/site/secured/review-manager/provider/useReviewsTools';
import { PROVIDER_DATA } from '@app/component/provider/FindProviderData';
import React from 'react';
import Utilities from '@util/Utilities';
import { ChatBubbleBottomCenterIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/solid';
import ReviewScoreTag from '@app/site/secured/review-manager/fragment/reviews-inbox/component/ReviewScoreTag';


const ReviewListItemFragment: React.FunctionComponent<{ reviewOutput: ReviewOutput, index: number }> = ({
																																																					reviewOutput,
																																																					index,
																																																				}) => {

	const tools = useReviewsTools();

	const isSelected = index === tools.index;

	const className = isSelected ? 'relative bg-blue-50 px-6 py-5 ring-2 ring-inset ring-blue-600'
		: 'relative bg-white px-6 py-5 focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-600 hover:bg-gray-50 cursor-pointer';

	const onSelectReview = () => {
		tools.setIndex(index);
	};

	return <li id={'' + reviewOutput.review.id} className={className} onClick={onSelectReview}>
		<div className="flex justify-between space-x-3">
			<div className="min-w-0 flex-1">
				<span className="absolute inset-0" aria-hidden="true" />
				<p className="truncate text-sm font-medium text-gray-900">
					{reviewOutput.hotelName}
				</p>
			</div>
			<div className="flex items-center justify-end gap-x-2">
				<div className="inline-block shrink-0 relative">
					{PROVIDER_DATA[reviewOutput.review.provider].icon}
				</div>
				<ReviewScoreTag score={reviewOutput.review.score} />
			</div>
		</div>
		<div className="mt-4 flex items-center justify-between">

			<p className="truncate text-xs font-medium text-gray-800">{reviewOutput.getTitle()}</p>
			<time
				className="flex-shrink-0 whitespace-nowrap text-xs text-gray-500">{Utilities.formatDateString(reviewOutput.review.reviewDate, 'MMM DD, YYYY')}</time>
		</div>
		<div className="mt-2">
			<div className="line-clamp-2 text-xs text-gray-600">
				{!reviewOutput.hasContent() && <div className="truncate w-full mb-1">No Content</div>}
				{reviewOutput.hasContent() && reviewOutput.getContent().map((c, i) => <div key={`content_${i}`}
																																									 className="truncate w-full mb-1">{c.text}</div>)}
			</div>
		</div>
		<div className="flex justify-end relative top-1.5">
			{reviewOutput.isReplied() && <ChatBubbleLeftRightIcon className="w-4 h-auto text-green-500" />}
			{!reviewOutput.isReplied() && <ChatBubbleBottomCenterIcon className="w-4 h-auto text-gray-400" />}
		</div>
	</li>;
};

export default ReviewListItemFragment;